import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { Container, Row, Col } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "./styles.css";

const RedesComponent = (props) => {
  return (
    <Fragment>
      <Container fluid className="footer-redes">
        <Row>
          <Col xs={{ span: 12, order: 3 }} md={12} lg={{ span: 2, order: 1 }} align="center">
            <div className="contenedor-made-with">
              <div className="made-with-contenedor">
                <a
                  href="https://girasolo.mx/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src="/assets/fuentes/iconos/CWLBGirasolo.svg" alt="" />
                </a>
              </div>
            </div>
          </Col>
          <Col className="ocultar-movil" xs={{ span: 12, order: 4 }} md={12} lg={{ span: 7, order: 2 }}></Col>
          <Col xs={{ span: 12, order: 2 }} md={12} lg={{ span: 1, order: 3 }} align="center">
            <div className="redes-sociales">
              <div className="redes-contenedor">
                <div id="content-redes">
                  <div>
                    <a
                      href="http://facebook.com/wearejack.mx"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img src="/assets/fuentes/iconos/Facebook.svg" alt="" />
                    </a>
                  </div>
                </div>
              </div>
              <div className="redes-contenedor">
                <div id="content-redes">
                  <div>
                    <a
                      href="https://www.instagram.com/wearejack.mx/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img src="/assets/fuentes/iconos/Instagram.svg" alt="" />
                    </a>
                  </div>
                </div>
              </div>
              <div className="redes-contenedor">
                <div id="content-redes">
                  <div>
                    <a
                      href="https://vimeo.com/wearejack"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img src="/assets/fuentes/iconos/IconoVimeo.svg" alt="" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </Col>
          <Col xs={{ span: 12, order: 1 }} md={12} lg={{ span: 2, order: 4 }} align="center">
            <div className="contenedor-habichuela">
              <div className="marca-registrda-contenedor">
                <a
                  href="https://www.lahabichuelamagica.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src="/assets/fuentes/iconos/LogoLaHabichuela.svg"
                    alt=""
                  />
                </a>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

RedesComponent.propTypes = {
  claseCss: PropTypes.string,
};

export default RedesComponent;
